
export default {
    props: ['name', 'items', 'value', 'placeholder', 'resetUrl'],
    data() {
        return {
            isOpen: false,
        }
    },
    computed: {
        hasLinks() {
            return this.items.some(item => item.url);
        },
        selectedValue() {
            const selectedOption = this.items.find(option => option.id === this.value);
            return selectedOption ? selectedOption.name : '';
        }
    },
    methods: {
        selectValue(value, event){
            if (event) {
                if (value.url && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
                event.preventDefault();
            }
            this.$emit('select', this.name, value.id);
            this.isOpen = false;
        },
        clearValue(event){
            if (event) {
                if (this.resetUrl && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
                event.preventDefault();
            }
            this.$emit('clear', this.name);
            this.isOpen = false;
        },
        close(){
            this.isOpen = false;
        },
    }
}
